import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngxs/store';
import {
  AbsenceCategoriesState,
  FetchAbsenceCategoriesIfNeededState,
} from '@wilson/absences';
import { AbsenceCategoryWithTranslatedName } from '@wilson/interfaces';
import { LocalizationState } from '@wilson/localization';
import { TransformMasterDataTranslationService } from '@wilson/non-domain-specific/master-data-translate';
import { combineLatest, map, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AbsenceRequestHelperService {
  private readonly store = inject(Store);
  private readonly transformMasterDataTranslationService = inject(
    TransformMasterDataTranslationService,
  );
  private isAbsenceCategoryStateInitialized = select(
    AbsenceCategoriesState.isStateInitialized,
  );

  hasAbsenceCategoriesLoadError$(): Observable<boolean> {
    return this.store.select(AbsenceCategoriesState.hasError);
  }

  getSortedAbsenceCategories(): Observable<
    AbsenceCategoryWithTranslatedName[]
  > {
    if (!this.isAbsenceCategoryStateInitialized()) {
      this.store.dispatch(new FetchAbsenceCategoriesIfNeededState());
    }

    return combineLatest([
      this.store.select(AbsenceCategoriesState.getAbsenceCategories),
      this.store.select(LocalizationState.getEntityLang),
    ]).pipe(
      map(([categories]) =>
        this.transformMasterDataTranslationService
          .transform(categories)
          .sort((a, b) => a.translatedName.localeCompare(b.translatedName)),
      ),
      shareReplay(1),
    );
  }
}
